export function fromRelationshipLegalTerms(legalTermsArray) {
    return legalTermsArray.map((legalTerms)=>{
        switch(legalTerms.type){
            case 'pdf':
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'pdf',
                    origin: 'custom',
                    name: legalTerms.displayName,
                    pdfUniqueName: legalTerms.pdf.pdfName,
                    pdfFileName: legalTerms.pdf.pdfFileName,
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
            case 'richText':
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'richText',
                    origin: 'system',
                    name: legalTerms.displayName,
                    richTextId: legalTerms.richText.textId,
                    richTextContent: [],
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
            case 'quill':
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'quill',
                    origin: 'custom',
                    name: legalTerms.displayName,
                    richTextId: legalTerms.quill.textId,
                    richTextContent: [],
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
        }
    });
}
export function toRelationshipLegalTermsDocuments(legalTerms, contentOverride) {
    switch(legalTerms.contentType){
        case 'pdf':
            return {
                type: 'pdf',
                displayName: legalTerms.name,
                legalTermsId: legalTerms.id,
                termsOfService: {
                    type: 'none'
                },
                pdf: {
                    pdfName: legalTerms.pdfUniqueName,
                    pdfFileName: legalTerms.pdfFileName
                }
            };
        case 'richText':
            return {
                type: 'richText',
                legalTermsId: legalTerms.id,
                displayName: legalTerms.name,
                termsOfService: {
                    type: 'none'
                },
                richText: {
                    textId: null
                }
            };
        case 'quill':
            var _legalTerms_richTextId;
            return {
                type: 'quill',
                legalTermsId: legalTerms.id,
                displayName: legalTerms.name,
                termsOfService: {
                    type: 'none'
                },
                quill: {
                    textId: (_legalTerms_richTextId = legalTerms.richTextId) !== null && _legalTerms_richTextId !== void 0 ? _legalTerms_richTextId : null
                },
                contentOverride: contentOverride ? {
                    type: 'custom',
                    custom: {
                        content: contentOverride
                    }
                } : {
                    type: 'none'
                }
            };
    }
}
